(function() {

    module.exports = {
        init: init,
        getTemplates: getTemplates,
        constructChapter: constructChapter,
    }

    var slidesData;
    var templates;
    var copy;


    function init(c) {
        copy = c
//        slidesData = d
        getTemplates()
//        console.log(d)
        $("body").css("overflow-y", 'hidden!important')
    }

    function getTemplates() {
       $.when(
            $.get("templates/slide--image.html"),
            $.get("templates/slide--text.html"),
            $.get("templates/slide--video-vimeo.html"),
            $.get("templates/slide--video-youtube.html"),
            $.get("templates/slide--image-library.html"),
            $.get("templates/slide--title.html"),
            $.get("templates/slide--video.html"),
            $.get("templates/slide--map-embed.html"),
            $.get("templates/slide--timeline.html")
       ).then(function(image, text, videoVimeo, videoYoutube, imageLibrary, titlePage, video, map, timeline) {
            templates = {
                'text': text[0],
                'image': image[0],
                'video-vimeo': videoVimeo[0],
                'video-youtube': videoYoutube[0],
                'image-library': imageLibrary[0],
                'title-page': titlePage[0],
                'video': video[0],
                'map-embed': map,
                'timeline': timeline,
            }

 //           constructChapter(slidesData, templates)
        })
    }

    var playing = false
    var start = true

    function constructChapter(chapData) {
        chapString = '';
        for (d in chapData) {
            data = chapData[d]
            data['copy'] = copy
            chapString = chapString + Mustache.render(String(templates[data.slideType]), data)
        }
        chapString += "<div class='overlay-close'>[ CLOSE X ]</div><div class='chapter-controls-container'><div class='chap-controls up'></div><div class='chap-controls down'></div></div>"
        console.log(chapString)

        $("#chapter-view-container").html(chapString).css("perspective", "300px").css('pointer-events', 'auto')
        $(".overlay-close").click(function() {
            overlayClose()
        })
        $(".slide-container").last().addClass("last")
        $(".chap-controls").click(function() {
            if($(this).hasClass('up')) {
                if($(".slide-container.active").hasClass("video")) {
                    $(".slide-container.active").find("video").get(0).pause()
                    playing = false
                }
                $(".slide-container.active").removeClass("active").addClass("pending").prev().addClass("active").removeClass("old")
                if($(".slide-container.active").hasClass("video")) {
                    $(".slide-container.active").find("video").fadeIn().get(0).play()
                    playing = true
                }
            } else {
                if (playing == true) {
                    $(".slide-container.active").find("video").get(0).pause()
                    playing = false
                }
                if ($(".slide-container.active").hasClass("title") && start == true) {
                    $(".slide-container.title").removeClass("active").addClass("old").next().addClass("active").removeClass("pending")
                    $(".slide-container.title .slide-content").fadeOut()
                    if ($(".slide-container.active").hasClass("video")) {
                        $(".slide-container.active").find("video").fadeIn().get(0).play()
                        playing = true
                    }
                    start = false
                } else if($(".slide-container.active").hasClass("last")){
                    overlayClose()
                } else {
                    $(".slide-container.active").removeClass("active").addClass("old").next().addClass("active").removeClass("pending")
                    if ($(".slide-container.active").hasClass("video")) {
                        $(".slide-container.active").find("video").fadeIn().get(0).play()
                        playing = true
                    }
                }
            }
        })
        setTimeout(function() {
            $(".chapter-controls-container").fadeIn()
        },2000)
            //.append(Mustache.render("<div class='last-slide'><a href='#/{{lang}}/squares'><h1>{{nextStory}}</h1></a><a href='#/{{lang}}/squares'><h3>{{continueExploring}}</h3></a></div>", copy))
        playing = false
        start = true



        $(".slide-container").first().addClass("active").removeClass("pending")
        setTimeout(function() {
 //           $("#main-view-container").fadeIn().css('min-height', '300vh')
            $(".slide-container").first().css("height", "100vh").css("opacity", "1")
            $(".title-background-panel").css("top", "0%")
            setTimeout(function() {
                $(".slide-container.title .slide-content").fadeIn()
            },500)
        },500)
    }

    $(document).keydown(function(e) {
        switchPage(e)
    });

    function switchPage(e) {
        switch(e.which) {
            case 40:
                if (playing == true) {
                    $(".slide-container.active").find("video").get(0).pause()
                    playing = false
                }
                if ($(".slide-container.active").hasClass("title") && start == true) {
                    $(".slide-container.title").removeClass("active").addClass("old").next().addClass("active").removeClass("pending")
                    $(".slide-container.title .slide-content").fadeOut()
                    if ($(".slide-container.active").hasClass("video")) {
                        $(".slide-container.active").find("video").fadeIn().get(0).play()
                        playing = true
                    }
                    start = false
                } else if($(".slide-container.active").hasClass("last")){
                    overlayClose()
                } else {
                    $(".slide-container.active").removeClass("active").addClass("old").next().addClass("active").removeClass("pending")
                    if ($(".slide-container.active").hasClass("video")) {
                        $(".slide-container.active").find("video").fadeIn().get(0).play()
                        playing = true
                    }
                }
                //down
                break;
            case 38:
                if($(".slide-container.active").hasClass("video")) {
                    $(".slide-container.active").find("video").get(0).pause()
                    playing = false
                }
                $(".slide-container.active").removeClass("active").addClass("pending").prev().addClass("active").removeClass("old")
                if($(".slide-container.active").hasClass("video")) {
                    $(".slide-container.active").find("video").fadeIn().get(0).play()
                    playing = true
                }
            //up



        }
    }

    function overlayClose() {
        $(".chapter-controls-container").fadeOut()
        $(".slide-container:not(.title), .slide-content").fadeOut()
//                        $(".last-slide").css("height", "50%").css("padding", "5%")
        setTimeout(function() {
            $(".title-background-panel .overlay").each(function (e) {
                if (e % 2 == 0) {
                    $(this).css("top", "-100%")
                } else {
                    $(this).css("top", "100%")
                }
            })
            $("#chapter-view-container").css("pointer-events", "none")
        }, 500)
    }

    function getTemplate(template) {
        var slideType = template
        var slideData = slidesData.filter(function(l) { return l.slideType === slideType} )
//        console.log(slideData)
        $.ajax({
            url: 'templates/slide--'+template+'.html',
            cache: false
            // dataType: "json"
        }).done(function(data) {
            for(s in slideData) {
                templates[slideData[s].slideId] = Mustache.render(data,slideData[s])
//                console.log(templates)
            }
        });
    }

})();